type TableOfContentsProps = {
    items: { label: string; anchor: string }[];
};

export const TableOfContents = ({ items }: TableOfContentsProps) => {
    if (items.length === 0) return null;

    return (
        <div className="relative w-full mx-auto max-w-container">
            <div className="mx-6 md:mx-0 grid md:grid-cols-14 md:gap-6">
                <div className="md:col-span-12 md:col-start-2">
                    <div className="flex gap-6 justify-between items-center relative">
                        <nav
                            aria-label="Table of contents"
                            className="
                                border-gray-900
                                border-2
                                md:border-none
                                px-4
                                py-6
                                md:px-0
                                w-full
                                relative
                                z-5
                                md:bg-transparent
                                md:mb-10
                                md:pb-0
                                md:pt-20
                                before:content-['']
                                before:absolute
                                before:w-screen
                                before:h-full
                                before:bg-ivory-100
                                before:-z-10
                                before:top-0
                                before:left-1/2
                                before:-translate-x-1/2
                                md:before:hidden
                            "
                        >
                            <h2 className="h5 overline mb-4 md:hidden">On This Page</h2>
                            <ul className="flex flex-col gap-6 lg:flex-row lg:flex-wrap lg:gap-x-6 lg:gap-y-4">
                                {items.map((item, index) => (
                                    <li key={item.anchor} className="flex items-center gap-2">
                                        <span className="h-xxs text-gray-500">
                                            {String(index + 1).padStart(2, '0')}
                                        </span>
                                        <a href={item.anchor} className="h-xxs border-b-out-inline">
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableOfContents;
